import { render, staticRenderFns } from "./ImgItem.vue?vue&type=template&id=02b0f678&"
import script from "./ImgItem.vue?vue&type=script&lang=js&"
export * from "./ImgItem.vue?vue&type=script&lang=js&"
import style0 from "./ImgItem.vue?vue&type=style&index=0&id=02b0f678&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImg: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppImg.vue').default})
